'use client'

import { FEATURE_FLAG_KEYS } from '@shared/constants'

import { useFlagsCompat } from '@podo/flags/react'

export type CouponPublishErrorCode =
  | 'INVALID_COUPON_TEMPLATE_PUBLISH' // 쿠폰 상태가 Normal이 아닐때
  | 'INVALID_COUPON_TEMPLATE_CODE_NOT_MATCH' // 존재하지 않는 쿠폰 코드일때
  | 'INVALID_COUPON_PUBLISH_TIME' // 쿠폰 지급 만료
  | 'COUPON_RACE_FAILED' // 쿠폰 발급 수량 소진
  | 'INVALID_COUPON_DUPLICATE_PUBLISH' // 이미 등록한 쿠폰
  | 'PARTNERS_NOT_FOUND' // 파트너스가 존재하지 않습니다.
  | 'PARTNERS_NOT_APPROVED' // 승인되지 않은 파트너스 입니다.
  | 'PARTNERS_EVENT_NOT_ACTIVE' // 현재 진행 중인 이벤트가 아니에요.
  | 'PARTNERS_EVENT_DUPLICATED' // 파트너스 이벤트 설정에 문제가 있습니다.
  | 'PARTNERS_EVENT_COUPON_NOT_FOUND' // 이벤트에 연결된 쿠폰 템플릿이 없습니다.
  | 'SELF_COUPON_REGISTRATION_NOT_ALLOWED' // 본인의 쿠폰코드는 등록할 수 없습니다.

// TODO: 추후 글로벌 진출시 오류 메시지 추가 필요
export const useCouponPublishErrorMessages = () => {
  const { coupon_error_message: couponErrorMessage } = useFlagsCompat([FEATURE_FLAG_KEYS.COUPON_ERROR_MESSAGE])

  const COUPON_PUBLISH_ERROR_MESSAGES = JSON.parse(couponErrorMessage.value as string) as Record<
    CouponPublishErrorCode,
    string
  >

  return {
    COUPON_PUBLISH_ERROR_MESSAGES,
  }
}
